import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LeadershipThemeSummaryLoadAction } from '../../domains/leadershipThemeSummary/actions.types';

import { LeadershipThemeSummaryLifecycle } from './types';

const initialState: LeadershipThemeSummaryLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<LeadershipThemeSummaryLifecycle, LeadershipThemeSummaryLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'LEADERSHIP_THEME_SUMMARY.LOAD_PENDING':
      return setPending();
    case 'LEADERSHIP_THEME_SUMMARY.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.leadershipThemeSummary);
    case 'LEADERSHIP_THEME_SUMMARY.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
